<template>
  <div id="aboutUs">

    <div class="kt-banner">
      <label class="love">为爱设计</label><br/>
      <label class="loveUs">Design for love</label>
    </div>


    <div class="aboutUsContent">
      <div class="left classImg">
        <img src="../../site/companyProfile.png">
      </div>
      <div class="right classContent">
        <p class="titleTxt">爱宝惟简介</p>
        <p class="textTxt">深圳市爱宝惟生物科技有限公司成立于2013年7月，是2014-2018年国内互联网医疗行业“百糖大战”中为数不多的竞争存活者，也是国内较早开展糖尿病远程数字干预的专业服务机构。团队目前拥有“糖糖圈”及“糖妈妈”两条细分专业产品线、一个线下糖尿病专科门诊、以及30余人的全职糖尿病医护人员。平台合作三甲医院136家，入驻专科医生1096人、日均医护消息互动次数54398次，培育同伴互助组长（peer support leader）87人。</p>
      </div>
      
      <div style="clear:both"></div>
    </div>

    <div class="aboutUsContent">
      <div class="right classImg">
        <img style="width:150px" src="../../site/ttqMobile.png">
      </div>
      <div class="left classContent">
        <p class="titleTxt">糖糖圈</p>
        <p class="textTxt">糖糖圈APP在2015年10月上线，2017年获得世界糖尿病基金会（WDF）资助。目前登记注册1型糖尿病患者人数42769人，日均患者血糖互助分享贴子500余条，已成为1型糖尿病医患交流平台。2014-2018年参与中国1型糖尿病登记管理项目，是中华医学会糖尿病分会中国1型糖尿病教育管理项目的合作伙伴，是中国医师协会中国1型糖尿病纵向队列建立项目科研、监察、随访管理服务平台。</p>
      </div>
      
      <div style="clear:both"></div>
    </div>

    <div class="aboutUsContent">
      <div class="left classImg">
        <img style="width:150px" src="../../site/tmmMobile.png">
      </div>
      <div class="right classContent">
        <p class="titleTxt">糖妈妈</p>
        <p class="textTxt">糖妈妈APP在2021年9月份上线，是安徽省妊娠合并糖尿病专病联盟58家妇产科医院的院外随访管理服务平台，项目旨在帮助妇产科建立院外妊娠糖尿病随访管理队列，为妇幼血糖健康提供全生命周期的健康管理方案。项目已经入驻中国科学技术大学附属第一医院以及安徽省妇幼保健院。</p>
      </div>
      
      <div style="clear:both"></div>
    </div>

    <div class="aboutUsContent">
      <div class="right classImg">
        <img src="../../site/honor.png">
      </div>
      <div class="left classContent history">
        <p class="titleTxt">历程与荣誉</p>
        <p class="textTxt">2018年获得天使轮融资估值4000万人民币;</p>
        <p class="textTxt">2018年获得民政部中国慈展会社会企业“中国好企业认证”;</p>
        <p class="textTxt">2019年社会创新家医疗社会创新TOP10;</p>
        <p class="textTxt">2019年获得美国Global perspectives on diabetes 杂志《Diabetes Voice》专题报道;</p>
        <p class="textTxt">2020年获得国家高新技术企业认证</p>
        <p class="textTxt" style="margin-top:20px; line-height:30px">2020年通过ISO/IEC 27701隐私信息管理体系（PIMS）及SO/IEC 27001信息安全管理体系（ISMS）认证;</p>
        <p class="textTxt" style="margin-top:20px;">2020年参与建立CDC中国1型糖尿病智能化管理与大数据中心;</p>
        <p class="textTxt">2020年荣获中国社会企业与影响力论坛“向光奖”;</p>
        <p class="textTxt">2020年参与创作并出版《我的血糖怪兽》系列科普绘本，获安徽省科普二等奖;</p>
        <p class="textTxt">2021年获得Pre-A轮融资估值3亿人民币;</p>
        <p class="textTxt">2021年获得亚洲银行家WEALTH&SOCIETY《2021财富与社会商业成就奖》;</p>
        <p class="textTxt">2021年参与成立“萱草1型糖尿病公益基金”;</p>

      </div>
      
      <div style="clear:both"></div>
    </div>

    <div class="aboutUsContent">
      <div class="left classImg">
        <img src="../../site/academicResearch.png">
      </div>
      <div class="right classContent history">
        <p class="titleTxt">学术研究</p>
        <p class="textTxt" style="margin-top:20px; line-height:30px">1.《The Design and Preliminary Evaluation of a Mobile Health Application TangTangQuan in Management of Type 1 Diabetes in China》,2017,ADA;</p>
        <p class="textTxt" style="margin-top:20px; line-height:30px">2.《基于移动APP的互助式同伴支持对1型糖尿病血糖管理的效果评价》（国家重点研发计划2017YFC1309603）,2020,中华内科</p>
        <p class="textTxt" style="margin-top:20px; line-height:30px">3.《DIY人工胰腺能够为1型糖尿病患者带来更好的血糖控制和更高的生活质量》（电子壁报-485），2020，ATTD;</p>
       
      </div>
      
      <div style="clear:both"></div>
    </div>

    <div class="aboutUsContent">
      <div class="right classImg">
        <img src="../../site/newIcon.png">
      </div>
      <div class="left classContent history">
        <p class="titleTxt">最新动态</p>
        <p class="textTxt">
          <a target="_blank" style="color:#00b9cd;text-decoration:underline" href="https://www.ttq.so/html/news/detail-14093.html">
            我司获得2023年度广东省科学技术奖公示
          </a>
        </p>
        <p class="textTxt">
          <a target="_blank" style="color:#00b9cd;text-decoration:underline" href="https://www.ttq.so/html/news/detail-13848.html">
            我司作为参与单位拟申报2022年中华医学会科技奖候选项目公示
          </a>
        </p>
        
      </div>
      
      <div style="clear:both"></div>
    </div>

    <!-- <div class="box">
      <p class="textP" style="margin-top:50px;height:auto">
        <span class="textSpan">
          <label>爱宝惟是谁？</label><br/>
          爱宝惟，谐音“爱包围”，是一个中国慈展会认证，世界糖尿病基金会（WDF）资助，中国联合健康<br/>
          产业投资，中华医学会糖尿病分会1型学组、广东省糖尿病防治中心、广东省精准医学学会支持下成立<br/>
          的社会企业。<br/>   

          团队开发并上线的糖糖圈App，已成为1型糖尿病医患交流平台，以解决中国1型糖尿病患者长<br>
          期存活者少、血糖控制差、并发症多、经济负担重、教育机会少等社会问题为首要目标，通过移动互联<br>
          网技术、可穿戴医疗设备、结合台湾糖尿病患教模式创新性的解决中国1型糖尿病管理现状的难题。<br>

          我们不仅针对1型糖尿病患者提供专业化患者教育、家庭教育、心理支持、血糖管理服务，而且努力在<br>
          让1型糖尿病患者能够愉快、便捷的正常生活，免受疾病及并发症的干扰。<br>

          <span style="color:#FA6C8D">团队开发上线的糖妈妈App，是针对妊娠糖尿病患者提供专业化的患者教育、标准化的妊娠糖课程、家<br>
          庭教育、心理支持、血糖管理服务，旨在解决妊娠糖尿病患者科学控糖，助力糖妈妈生出健康宝宝。</span>

        </span>
        <i class="zp1"></i>
      </p>
      <p class="textP">
        <i class="zp0"></i>
        <span class="textSpan" style="text-align: right">
          <label>全国首家1型糖尿病专科诊所</label><br/>
          深圳爱宝惟诊所（糖糖圈糖尿病服务中心）位于深圳市南山区，由内分泌专<br/>
          科医师、糖尿病教育师、营养师、心理咨询师等组成，依据并遵从“循证”<br/>
          的医学诊疗方法，为患者提供国际标准的医疗服务。诊所充分考虑1型患者<br/>
          深层次需求，秉持“让1型糖尿病生活更美好”的服务理念，设置患者教育、<br/>
          营养、检验、心理等多个类目。可在平台、公众号、官网等处进行预约。
        </span>
      </p>
      <p class="textP">
        
        <span class="textSpan">
          <label>7×24小时的应急支持</label><br/>
          1型糖尿病是一个终身性疾病，生活起来并不容易。需要患者与家属能够熟<br/>
          练掌握疾病知识，成为自己的医生，才能更好的享受生活。为此，我们提供<br/>
          每周7天、每天24小时的应急响应支持，帮助患者及家属解决疾病带来的困难。<br/>
          您可以通过邮箱<font style="font-size: 18px" color="#00b9cd">support@ttq.so或4008-365596</font>与我们联系。
        </span>
        <i class="zp2"></i>
      </p>
      <p class="textP">
        <i class="zp3"></i>
        <span class="textSpan" style="text-align: right">
        <label>社会责任</label><br/>
        1.我们将致力于为儿童、青少年糖尿病患者及家庭提供支援；<br/>
        2.凝聚社会力量以争取年轻患者在求学、求职中的合法权益；<br/>
        3.推动、完善、建立1型糖尿病社会救助保障制度；<br/>
        4.提升大众对1型糖尿病的理解，宣传治疗糖尿病的科学治疗方法。
        </span>
        

      </p>
      <p class="textP">
        
        <span class="textSpan">
          <label>建档跟踪</label><br/>
          糖糖圈是中国1型糖尿病登记管理项目与中国1型糖尿病教育管理项目的参与者之一，欢<br/>
          迎您加入我们并在糖糖圈建档跟踪。我们将会有专业的患教师与您长期保持沟通。<br/>
          <font style="font-size: 18px" color="#00b9cd">通过我们远程教育跟踪以及同伴互助的方式，在糖糖圈的长期用户中，小于18岁患者的<br/>
          糖化血红蛋白达标率高达82.73%（A1C≤7.5%），大于18岁患者的糖化血红蛋白达标率<br/>
          高达88.82%（A1C≤7.5%），这无论是在国内还是国际上，都是极其好的结果</font>
        </span>
        <i class="zp4"></i>
      </p>
      <p class="textP">
        <i class="zp5"></i>
        <span class="textSpan" style="text-align: right">
        <label>科学研究</label><br/>
        中国1型糖尿病登记管理项目<br/>
        中国1型糖尿病教育管理项目<br/>
        中国1型糖尿病合并妊娠结局研究项目<br/>
        广东省1型糖尿病转化医学研究项目<br/>
        广东省级科技项目：1型糖尿病教育课程开发及科普平台建设<br/>
        广东省级科技项目：1型糖尿病餐后血糖预测模型研究项目
        </span>
        
      </p>
    </div> -->

    <footerBottomer style="margin-top:130px"></footerBottomer>

    <!-- <div class="box1">
      <div class="boxEnd-1">
        <i class="logo1"></i>
        <p>400热线：400-836-5596<br/>客服电话：0755-27299992<br/>渠道合作：caoqifan@ttq.so<br/>微信客服：ttqcare<br/>地址：广东省深圳市宝安区西乡街道宝民二路IDT研发中心4层</p>
      </div>
      <div class="boxEnd-2">
        <span class="ewm1"><label class="wxb">官方微博</label></span>
        <span class="ewm2"><label class="wxb">官方微信</label></span>
        <i class="xian"></i>
        <span class="yptu">
          <label class="ypwz">雅培辅理善瞬感软件</label>
            <a class="mac" href="https://freestyleserver.com/distribution/fxaa20.aspx?product=fslibre&version=latest&os=mac&region=cn&language=xx_yy"></a>
            <a class="win" href="https://freestyleserver.com/distribution/fxaa20.aspx?product=fslibre&version=latest&os=win&region=cn&language=xx_yy"></a>
        </span>
      </div>
    </div>
    <div style="background: #f7f8fa">
      <div class="box-ends">
        Copyright @ 2014-2024 aibaowei.All Rights Reserved
        <label>爱宝惟生物科技有限公司版权所有</label>
        <a href="http://www.beian.miit.gov.cn">粤ICP备14072944号</a>
      </div>
    </div> -->
  </div>
</template>

<script>
  import footerBottomer from './footerBottomer.vue'
  export default {
    name: 'aboutUs',
    components: {
     footerBottomer
  	},
    data () {
      return {

      }
    },
    methods: {

    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #aboutUs{margin-top: 90px;}
  .kt-banner{background: url("../../site/welcome.png") no-repeat center center;height: 420px;width: 100%;min-width: 1200px}
  .gs-title{color: #333;font-size: 28px;text-align: left;border-bottom: 1px solid #d9d9d9;padding-bottom: 10px;margin-bottom: 40px}
  .box{width: 1200px;margin: 0 auto;text-align: center;border-bottom: 1px solid #d9d9d9;padding:60px 0 100px 0;}
  .box1{width: 1200px;margin: 0 auto;text-align: center;padding:60px 0;}
  .zp1{width: 272px;height: 272px;background: url("../../site/zp1.png");vertical-align: top;margin-left: 100px}
  .zp0{width: 272px;height: 272px;background: url("../../site/zss.jpg") no-repeat center;background-size: cover; margin-right: 250px;vertical-align: top;border-radius: 100%}
  .zp2{width: 272px;height: 272px;background: url("../../site/zp2.png");margin-left: 250px;vertical-align: top}
  .zp3{width: 272px;height: 272px;background: url("../../site/zp3.png");vertical-align: top;margin-right: 350px}
  .zp4{width: 272px;height: 272px;background: url("../../site/zp4.png");margin-left: 100px;vertical-align: top}
  .zp5{width: 272px;height: 272px;background: url("../../site/zp5.png");vertical-align: top;margin-right: 350px}
  .textP{height: 272px;position: relative;color: #8c8c8c;font-size: 16px;margin-top: 150px}
  .textSpan{display: inline-block;vertical-align: top;line-height: 30px;text-align: left;}
  .textSpan label{color: #545353;font-size: 40px;margin: 30px 0 50px 0;}
  .love{text-shadow:#bdc6cc 2px 2px 2px;color: #fff;font-size: 100px;margin:  88px 0 0 355px;}
  .loveUs{text-shadow:#bdc6cc 2px 2px 2px;color: #fff;font-size: 40px;position: relative;top: 0;left: 355px;letter-spacing: 6px}

  .left{float: left;}
  .right{float: right;}
  .aboutUsContent{margin: auto; margin-top: 120px; width: 1086px;}
  .classContent{width: 755px;height: auto;}
  .classImg{width: 250px;height: auto;text-align: center;}
  .classImg img{width: 250px;}
  .titleTxt{font-size: 26px;color: #323232;}
  .textTxt{margin-top: 40px; font-size: 16px;color: #666;line-height: 32px;}
  .history .textTxt{line-height: 0px;}
</style>



// WEBPACK FOOTER //
// aboutUs.vue?d1118a9e